import { Icon, IconSize, IconVariants, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import Trans from "@/components/Trans/Trans";

const RulebookInstructionsPrivateNotice = () => (
  <div
    className="flex items-start gap-3 rounded-[14px] border border-dashed border-gray-6 dark:border-gray-8 p-4"
    data-testid="RulebookProfile-InstructionsPrivate"
  >
    <Icon icon={IconVariants.LOCK} size={IconSize.SMALL} className="mt-0.5 flex-none text-gray-11" />
    <div className="flex flex-col gap-1">
      <Text variant={TextVariants.LABEL_MEDIUM_BOLD}>
        <Trans i18nKey="rulebook:profile.instructionsPrivate.title" />
      </Text>
      <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="max-w-[640px] leading-[1.5] text-gray-11">
        <Trans i18nKey="rulebook:profile.instructionsPrivate.body" />
      </Text>
    </div>
  </div>
);

export default RulebookInstructionsPrivateNotice;
